import { useEffect } from "react";
import {  useSelector } from "react-redux";
import useFacultiesEditor from "../../../../../hooks/faculties/useFacultiesEditor";
import useFacultiesGet from "../../../../../hooks/faculties/useFacultiesGet";
import { selectIsCreatingFaculty, selectIsEditingFaculty } from "../../../../../redux/faculties/selectors";
import { Box, Grid, Text, Button, Input } from "@flexisaf/flexibull2";
import Theme from "../../../../../theme";
import { useForm } from "react-hook-form";
import fontSize from "../../../../../utils/typography";

const getDefaultFields = () => ({
  name: "",
});

const FacultyEditor = (props) => {
  const isCreatingFaculty = useSelector(selectIsCreatingFaculty);
  const isEditingFaculty = useSelector(selectIsEditingFaculty);
  const { createFaculty, editFaculty} = useFacultiesEditor();
  const { refetch } = useFacultiesGet();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      ...getDefaultFields(),
    },
  });

  useEffect(() => {
    if (props.data?.id) {
      setValue("name",  props?.data?.name );
    } 
  }, [props?.data, setValue]);

  const handleClose = () => {
    reset({
      ...getDefaultFields(),
    });
    props.closeModal();
  };

  const handleCreate = (v) => {
    let payload = {
      data: {
        ...v,
      },
      callback: () => {
        handleClose();
        refetch();
      },
    };
    createFaculty(payload);
  };

  const handleEdit = (v) => {
    let payload = {
      data: {
        id: props?.data?.id,
        ...v,
      },
      callback: () => {
        handleClose();
        refetch();
      },
    };
    editFaculty(payload);
  };

  return (
    <Box>
      <Grid default="auto max-content" responsive={false} >
        <Box pad="20px 20px">
          <Text {...fontSize.h3} uppercase>
            {props?.data?.id ? "Edit" : "Add a new"} Faculty
          </Text>
        </Box>
      </Grid>
      <Box pad="10px 20px">
        <Grid default="1fr" gap="24px">
          <Input
            spaceTop
            type="text"
            label={"Name"}
            required={true}
            placeholder={`Ex: Law`}
            value={watch("name")}
            {...register("name", {
              required: `Name is required`,
            })}
            error={errors.name?.message}
            onChange={({ target: { value } }) => setValue("name", value)}
          />
        </Grid>
      </Box>

      <Grid default="auto max-content" responsive={false}>
        <Box pad="24px">
          <Button
            onClick={handleClose}
            pale
            color="rgba(0,0,0,0.0)"
            fontColor={Theme.PrimaryGrey}
          >
            Cancel
          </Button>
        </Box>
        <Box pad="24px">
          <Button
            onClick={handleSubmit((v) => {
              if (props?.data?.id) {
                handleEdit(v);
              } else {
                handleCreate(v);
              }
            })}
            progress={props?.data?.id ? isEditingFaculty : isCreatingFaculty}
          >
            {props?.data?.id ? "Edit" : "Create"}
          </Button>
        </Box>
      </Grid>
    </Box>
  );
};

export default FacultyEditor;
